import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core'
import { toSignal } from '@angular/core/rxjs-interop'
import { NativeBiometricService } from '@services/native-biometric.service'
import { AuthService } from '@services/auth.service'

/**
 * Cobertura de bloqueio do app (spec 058). A casca a pede ao voltar do segundo plano depois de 5 minutos com a
 * biometria ligada; o conteúdo fica escondido até a biometria. Ao abrir do zero quem bloqueia é a própria casca, antes
 * do WebView, então isto não aparece.
 */
@Component({
	selector: 'app-native-app-lock',
	templateUrl: './native-app-lock.component.html',
	styleUrl: './native-app-lock.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class NativeAppLockComponent {
	private readonly biometric = inject(NativeBiometricService)
	private readonly authService = inject(AuthService)

	readonly state = toSignal(this.biometric.lockState$, { initialValue: 'unlocked' as const })
	readonly retrying = signal(false)

	async retry() {
		if (this.retrying()) {
			return
		}

		this.retrying.set(true)

		try {
			await this.biometric.unlock()
		} finally {
			this.retrying.set(false)
		}
	}

	/** Encerra a sessão (no servidor e no aparelho) e leva ao login. */
	signInWithPassword() {
		this.biometric.release()
		this.authService.logout()
	}
}
